import React from 'react';
import {
  LayoutDashboard,
  BookOpen,
  Users,
  ArrowLeftRight,
  ClipboardList,
  Award,
  UserPlus,
  Settings,
  LogOut
} from 'lucide-react';
import "../styles/Sidebar.css";

export default function Sidebar({ role, active, onNavigate }) {
  const adminItems = [
    ['dashboard', 'Dashboard', <LayoutDashboard size={16} />],
    ['content', 'Courses & Certifications', <BookOpen size={16} />],
    ['partners', 'Partners', <Users size={16} />],
    ['allocation', 'Allocation', <ArrowLeftRight size={16} />],
    ['requests', 'Requests', <ClipboardList size={16} />],
    ['certificates', 'Certificates', <Award size={16} />],
    // Admin-only — manages course categories + partner industries.
    ['settings', 'Settings', <Settings size={16} />]
  ];

  const partnerItems = [
    ['dashboard', 'Dashboard', <LayoutDashboard size={16} />],
    ['content', 'My Courses & Certifications', <BookOpen size={16} />],
    ['register', 'Student Registration', <UserPlus size={16} />],
    ['student', 'My Student', <UserPlus size={16} />],
    ['requests', 'Requests', <ClipboardList size={16} />],
    ['certificates', 'Certificates', <Award size={16} />]
  ];

  const items = role === 'partner' ? partnerItems : adminItems;

  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brand-mark">
          <img src="/AI_academy/logo.png" alt="Wiiz" />
        </div>
      </div>

      <div className="role-pill">
        {role === 'partner' ? 'PARTNER' : 'ADMIN'} PORTAL
      </div>

      <nav>
        {items.map(([id, label, icon]) => (
          <button
            key={id}
            className={active === id ? 'nav-item active' : 'nav-item'}
            onClick={() => onNavigate(id)}
            type="button"
          >
            <span>{icon}</span>
            {label}
          </button>
        ))}
      </nav>

      <button
        className="logout"
        onClick={() => onNavigate('__logout')}
        type="button"
      >
        <span><LogOut size={14} /></span>
        Logout
      </button>
    </aside>
  );
}